export const calculatePageCount = (characterCount: number, charactersPerPage: number): number => {
  return characterCount > 0 ? Math.ceil(characterCount / charactersPerPage) : 0;
};

export const calculatePageTotalCost = (pageCount: number, pageCost: number): number => {
  return pageCount * pageCost;
};

export const calculateAnswerTotalCost = (answerRequired: boolean, answerCount: number, answerCost: number): number => {
  return answerRequired ? answerCount * answerCost : 0;
};

export const calculateAttachmentTotalCost = (
  photoCount: number,
  crosswordAttached: boolean,
  crosswordCount: number,
  sudokuAttached: boolean,
  sudokuCount: number,
  newsAttached: boolean,
  sportsNewsAttached: boolean,
  photoCost: number,
  sudokuCost: number,
  crosswordCost: number,
  newsCost: number,
): number => {
  let attachmentTotalCost = 0;
  if (photoCount > 0) {
    attachmentTotalCost += photoCost * photoCount;
  }
  if (crosswordAttached) {
    attachmentTotalCost += crosswordCost * (crosswordCount ? crosswordCount : 1);
  }
  if (sudokuAttached) {
    attachmentTotalCost += sudokuCost * (sudokuCount ? sudokuCount : 1);
  }
  if (newsAttached) {
    attachmentTotalCost += newsCost;
  }
  if (sportsNewsAttached) {
    attachmentTotalCost += newsCost;
  }
  return attachmentTotalCost;
};

export const calculateAdditionalCost = (
  answerRequired: boolean,
  answerCount: number,
  answerCost: number,
  photoCount: number,
  crosswordAttached: boolean,
  crosswordCount: number,
  sudokuAttached: boolean,
  sudokuCount: number,
  newsAttached: boolean,
  sportsNewsAttached: boolean,
  photoCost: number,
  sudokuCost: number,
  crosswordCost: number,
  newsCost: number,
): number => {
  let additionalCost = 0;
  additionalCost += calculateAnswerTotalCost(answerRequired, answerCount, answerCost);
  additionalCost += calculateAttachmentTotalCost(
    photoCount,
    crosswordAttached,
    crosswordCount,
    sudokuAttached,
    sudokuCount,
    newsAttached,
    sportsNewsAttached,
    photoCost,
    sudokuCost,
    crosswordCost,
    newsCost,
  );
  return additionalCost;
};

export const calculateTotalCost = (
  pageCount: number,
  answerRequired: boolean,
  answerCount: number,
  photoCount: number,
  crosswordAttached: boolean,
  crosswordCount: number,
  sudokuAttached: boolean,
  sudokuCount: number,
  newsAttached: boolean,
  sportsNewsAttached: boolean,
  letterCost: number,
  answerCost: number,
  photoCost: number,
  sudokuCost: number,
  crosswordCost: number,
  newsCost: number,
): number => {
  let totalCost = 0;
  totalCost += calculatePageTotalCost(pageCount, letterCost);
  totalCost += calculateAdditionalCost(
    answerRequired,
    answerCount,
    answerCost,
    photoCount,
    crosswordAttached,
    crosswordCount,
    sudokuAttached,
    sudokuCount,
    newsAttached,
    sportsNewsAttached,
    photoCost,
    sudokuCost,
    crosswordCost,
    newsCost,
  );
  return totalCost;
};
